// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import * as yup from "yup";
import PropTypes from "prop-types";
import useTranslation from "next-translate/useTranslation";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { DialogTitle, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import Image from "next/image";

import { useStepperContext } from "@/hooks";
import { Dialog, Button, Link, Form, Stepper, Grid, Typography } from "@/components/core";

/**
 * @param {{
 * open: Boolean
 * setOpen: Function
 * handleConfirm: Function
 * }}
 */
export default function CreateEuropeAccountDialog({ open, setOpen, handleConfirm }: any) {
  const theme = useTheme();
  const { t } = useTranslation();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const formProps = {
    initialValues: {
      agreement: false,
    },
    validationSchema: yup.object().shape({
      agreement: yup.bool().isTrue().required(),
    }),
    onSubmit: () => {
      setOpen(false);
      handleConfirm();
    },
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} defaultTitle>
      <Form {...formProps}>
        <DialogTitle fontSize={25} textAlign="center" fontWeight={20}>
          {t("accounts:europeAccount.openAccount")}
        </DialogTitle>
        <Grid.Item sx={{ display: "flex", justifyContent: "center" }}>
          <Image src="/images/avrupa.png" alt="uption" width={130} height={130} />
        </Grid.Item>
        <Stepper hideStepLabels>
          <Stepper.Step>
            <FirstStep handleClose={handleClose} />
          </Stepper.Step>
          <Stepper.Step>
            <SecondStep handleClose={handleClose} />
          </Stepper.Step>
        </Stepper>
      </Form>
    </Dialog>
  );
}

CreateEuropeAccountDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

function FirstStep({ handleClose }: any) {
  const { t } = useTranslation();
  const stepper = useStepperContext();

  const handleContinue = () => {
    stepper.moveNext();
  };

  return (
    <>
      <DialogContent>
        <DialogContentText margin={1} fontSize={15} display="list-item">
          {t("accounts:europeAccount.firstStep.text1")}
        </DialogContentText>
        <DialogContentText margin={1} fontSize={15} display="list-item">
          {t("accounts:europeAccount.firstStep.text2")}
        </DialogContentText>
        <DialogContentText margin={1} fontSize={15} display="list-item">
          {t("accounts:europeAccount.firstStep.text3")}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          height: 80,
          verticalAlign: "center",
        }}
      >
        <Button
          autoFocus
          variant="outlined"
          onClick={handleClose}
          sx={{ margin: "auto", padding: "0.7rem 6rem", borderRadius: 2 }}
        >
          {t("common:cancel")}
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={handleContinue}
          autoFocus
          sx={{ margin: "auto", padding: "0.7rem 6rem", borderRadius: 2 }}
        >
          {t("common:nextButton")}
        </Button>
      </DialogActions>
    </>
  );
}

FirstStep.propTypes = {
  handleClose: PropTypes.func,
};

function SecondStep() {
  const { t } = useTranslation();

  return (
    <>
      <DialogContent>
        <Grid sx={{ paddingInline: 2, width: "100%" }}>
          <Typography sx={{ paddingBottom: 1 }}>
            {t("accounts:europeAccount.secondStep.representativeName")}
          </Typography>
        </Grid>
        <Grid sx={{ paddingInline: 2, width: "100%" }}>
          <Form.TextField variant="filled" name="userName1" />
        </Grid>
        <Grid sx={{ paddingInline: 2, width: "100%" }}>
          <Typography sx={{ paddingBottom: 1 }}>
            {t("accounts:europeAccount.secondStep.companyName")}
          </Typography>
        </Grid>
        <Grid sx={{ paddingInline: 2, width: "100%" }}>
          <Form.TextField variant="filled" name="userName" />
        </Grid>
        <Grid sx={{ paddingInline: 2, width: "100%" }}>
          <Typography sx={{ paddingBottom: 1 }}>
            {t("accounts:europeAccount.secondStep.emailAddress")}
          </Typography>
        </Grid>
        <Grid sx={{ paddingInline: 2, width: "100%" }}>
          <Form.TextField variant="filled" name="userName" />
        </Grid>
        <Grid sx={{ paddingInline: 2, width: "100%" }}>
          <Typography sx={{ paddingBottom: 1 }}>
            {t("accounts:europeAccount.secondStep.phoneNumber")}
          </Typography>
        </Grid>
        <Grid sx={{ paddingInline: 2, width: "100%" }}>
          <Form.TextField variant="filled" name="userName" />
        </Grid>
      </DialogContent>
      <DialogContent sx={{ display: "flex" }}>
        <Form.Checkbox name="agreement" />
        <div>
          <DialogContentText>{t("accounts:europeAccount.secondStep.permission")}</DialogContentText>
          <Link href="/"> {t("accounts:europeAccount.secondStep.agreement")}</Link>
        </div>
      </DialogContent>
      <DialogActions
        sx={{
          height: 80,
          verticalAlign: "center",
        }}
      >
        <Button
          variant="contained"
          color="warning"
          type="submit"
          autoFocus
          sx={{ margin: "auto", padding: "0.7rem 6rem", borderRadius: 2 }}
        >
          {t("common:confirm")}
        </Button>
      </DialogActions>
    </>
  );
}
